import { Box, Chip, Grid, Tooltip } from "@mui/material";
import { RouteRequestResult } from "../../generated/gpb/api/route";
import { categoryToRiskLevel, getEnumFromOrdinal } from "../../app/riskLevel";
import { RiskCategory } from "../../generated/gpb/api/risk";
import ImpactIcon from "../risk/ImpactIcon";
import { MUTED_GREEN } from "../trips/form/BorderWithLabel";

type RouteHeaderProps = {
    routeResult: RouteRequestResult,
    maxRisk: number,
    label: string | undefined,
};

const RouteHeader = ( { routeResult, maxRisk, label }: RouteHeaderProps ) =>
{
    const variationTag = routeResult.variationTag;
    const riskEnum = getEnumFromOrdinal( RiskCategory, maxRisk );
    const riskCategory = categoryToRiskLevel( riskEnum ?? RiskCategory.RISK_CATEGORY_UNSPECIFIED );
    return (
        <Grid container alignItems = "center" justifyContent = "space-between" sx = {{ paddingBottom: "8px" }}>
            <Grid item>
                <Box display = "flex" alignItems = "center" gap = {1}>
                    {riskEnum !== undefined && (
                        <Tooltip title = {riskCategory}>
                            <span style = {{ display: "inline-flex", alignItems: "center" }}>
                                <ImpactIcon level = {riskCategory} width = {24} includeText = {false}/>
                            </span>
                        </Tooltip>
                    )}
                    {label !== undefined && (
                        <Chip
                            label = {label}
                            sx = {{ fontSize: "11px", height: "50%" }}
                            style = {{ backgroundColor: MUTED_GREEN }}
                        />
                    )}
                </Box>

            </Grid>

            <Grid item>
                <Chip
                    label = {variationTag}
                    sx = {{ fontSize: "11px", height: "50%" }}
                />
            </Grid>
        </Grid>
    );
};

export default RouteHeader;
